import { render, staticRenderFns } from "./StatsCardComponent.vue?vue&type=template&id=75bed0c2&scoped=true"
import script from "./StatsCardComponent.vue?vue&type=script&lang=js"
export * from "./StatsCardComponent.vue?vue&type=script&lang=js"
import style0 from "./StatsCardComponent.vue?vue&type=style&index=0&id=75bed0c2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75bed0c2",
  null
  
)

export default component.exports